function decodeBase64Json(dataUrl: string): any | null {
  try {
    const base64 = dataUrl.split(',')[1];
    const jsonString = atob(base64);
    return JSON.parse(jsonString);
  } catch {
    return null;
  }
}

function isValidLottie(json: any): boolean {
  return (
    typeof json === 'object' &&
    typeof json.v === 'string' &&
    typeof json.fr === 'number' &&
    typeof json.ip === 'number' &&
    typeof json.op === 'number' &&
    typeof json.w === 'number' &&
    typeof json.h === 'number' &&
    Array.isArray(json.layers)
  );
}

export async function validateLottieFile(
  data: unknown,
): Promise<{ isLottie: boolean; animationData: any | null }> {
  // Case 1: JSON object in memory
  if (typeof data === 'object' && data !== null) {
    const isValid = isValidLottie(data);
    return { isLottie: isValid, animationData: isValid ? data : null };
  }

  if (typeof data === 'string') {
    // Case 2: base64
    if (data.startsWith('data:application/json;base64,')) {
      const json = decodeBase64Json(data);
      const isValid = !!json && isValidLottie(json);
      return { isLottie: isValid, animationData: isValid ? json : null };
    }

    // Case 3: url
    if (data.startsWith('http')) {
      try {
        const res = await fetch(data);
        if (!res.ok) return { isLottie: false, animationData: null };
        const json = await res.json();
        const isValid = isValidLottie(json);
        return { isLottie: isValid, animationData: isValid ? json : null };
      } catch {
        return { isLottie: false, animationData: null };
      }
    }
  }

  return { isLottie: false, animationData: null };
}
